import $date from '@/services/date'
import { isEmpty } from 'lodash'

const isCacheFresh = ({
  cacheDuration,
  durationUnits,
  lastUpdated,
  forceRefresh = false,
}) => {
  // If not being forced to refresh and it hasn't been longer than staleness threshold
  // return resource without API call
  return (
    !isEmpty(lastUpdated) &&
    !forceRefresh &&
    $date().diff(lastUpdated, durationUnits) < cacheDuration
  )
}

const getSavedState = (key) => {
  const item = window.localStorage.getItem(key)
  return item && item !== 'undefined' ? JSON.parse(item) : ''
}

const saveState = (key, state) => {
  window.localStorage.setItem(key, JSON.stringify(state))
}

const deleteState = (key) => {
  saveState(key, null) // extra precaution
  window.localStorage.removeItem(key)
}

export { isCacheFresh, saveState, deleteState, getSavedState }
